import voca from 'voca';

export const STRING_STYLE = Object.freeze({ U: 'U', L: 'L', T: 'T', C: 'C' });

const CASE_MAP = Object.freeze({
  [STRING_STYLE.U]: voca.upperCase,
  [STRING_STYLE.L]: voca.lowerCase,
  [STRING_STYLE.T]: voca.titleCase,
  [STRING_STYLE.C]: voca.camelCase,
});

export const stringDecor = (value, { strict = false, trim = false, style = '' } = {}) => {
  if (value == null || value === '') return value;

  let result = strict ? String(value) : value;
  if (trim) result = voca.trim(result);

  const transform = CASE_MAP[style];
  return transform ? transform(result) : result;
};
